import React from 'react';
import PropTypes from 'prop-types';
import { ListGroup, Row, Col } from 'react-bootstrap';

const EstadoCuentaLista = ({ rfcSeleccionado, movimientosFiltrados }) => {
    return (
        <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
            <ListGroup variant="flush">
                {!rfcSeleccionado ? (
                    <ListGroup.Item className="text-center text-600 py-5">
                        <i className="fas fa-exclamation-triangle fa-2x mb-3 text-warning"></i>
                        <p className="mb-0">Seleccione un RFC para ver los movimientos</p>
                    </ListGroup.Item>
                ) : movimientosFiltrados && movimientosFiltrados.length > 0 ? (
                    movimientosFiltrados.map((movimiento) => (
                        <ListGroup.Item
                            key={movimiento.id}
                            className="border-start border-4 hover-shadow transition-base"
                            style={{
                                borderColor: movimiento.tipo === 'ingreso' ? '#28a745' : '#dc3545',
                                cursor: 'pointer'
                            }}
                        >
                            <Row className="align-items-center">
                                <Col xs={2} className="text-center">
                                    <div
                                        className={`rounded-circle d-inline-flex align-items-center justify-content-center`}
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            backgroundColor: movimiento.tipo === 'ingreso' ? '#d4edda' : '#f8d7da'
                                        }}
                                    >
                                        <i
                                            className={`fas ${movimiento.tipo === 'ingreso' ? 'fa-arrow-down text-success' : 'fa-arrow-up text-danger'}`}
                                        ></i>
                                    </div>
                                </Col>
                                <Col xs={7}>
                                    <div className="fw-semi-bold text-800 fs--1 mb-1">
                                        {movimiento.descripcion}
                                    </div>
                                    <div className="text-600 fs--2">
                                        <i className="far fa-calendar me-1"></i>
                                        {movimiento.fecha}
                                        <span className="mx-2">•</span>
                                        <i className="fas fa-hashtag me-1"></i>
                                        {movimiento.referencia}
                                    </div>
                                </Col>
                                <Col xs={3} className="text-end">
                                    <div
                                        className={`fw-bold fs-0 ${movimiento.tipo === 'ingreso' ? 'text-success' : 'text-danger'}`}
                                    >
                                        {movimiento.tipo === 'ingreso' ? '+' : '-'}

                                        ${movimiento.monto.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                                    </div>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    ))
                ) : (
                    <ListGroup.Item className="text-center text-600 py-4">
                        <i className="fas fa-info-circle me-2"></i>
                        No hay movimientos para el período seleccionado
                    </ListGroup.Item>
                )}
            </ListGroup>
        </div>
    );
};



EstadoCuentaLista.propTypes = {
    rfcSeleccionado: PropTypes.string,
    movimientosFiltrados: PropTypes.array
};

export default EstadoCuentaLista;
